<template>
  <div v-if="ready" class="photo-info-wrapper">
    <div class="photo-wrapper">
      <img :src="image.urls.regular" alt="image.alt_description" />
    </div>
    <div class="info-wrapper">
      <div class="user-wrapper">
        <div class="left-side">
          <div class="avatar-wrapper">
            <vs-avatar
              size="80"
              history
              history-gradient
              @click="handleUserPage(image.user.username)"
            >
              <img :src="image.user.profile_image.large" alt="profile img" />
            </vs-avatar>
          </div>
          <div class="name" @click="handleUserPage(image.user.username)">
            {{ image.user.first_name }} {{ image.user.last_name }}
          </div>
        </div>

        <div class="btn-wrapper">
          <vs-button
            icon
            color="danger"
            border
            :active="active == 2"
            @click="active = 2"
          >
            <box-icon name="heart" type="solid" color="#ff0000"></box-icon>
          </vs-button>
          <vs-button icon color="warn" gradient>
            <box-icon name="plus" color="#ffffff"></box-icon>
          </vs-button>
          <vs-button icon shadow>
            <box-icon name="share-alt" type="solid" color="#4e4e4e"></box-icon>
          </vs-button>

          <vs-button
            @click="handleDownload(image.links.download_location, image.id)"
          >
            <box-icon name="download" color="#ffffff"></box-icon>
            Download
          </vs-button>
        </div>
      </div>
      <div class="main-info-wrapper">
        <div class="title">Info</div>
        <div class="stats">
          <div class="main">
            <span>
              Views
            </span>
            <div class="count">
              {{ image.views }}
            </div>
          </div>
          <div class="main">
            <span>
              Downloads
            </span>
            <div class="count">
              {{ image.downloads }}
            </div>
          </div>
        </div>
        <div class="line">
          <hr />
        </div>

        <div class="camera-info">
          <div class="info">
            <div class="camera-title">
              Camera Make
            </div>
            <div class="main-camera-info">
              <span v-if="image.exif.make == null">--</span>
              {{ image.exif.make }}
            </div>
          </div>
          <div class="info">
            <div class="camera-title">
              Camera Model
            </div>
            <div class="main-camera-info">
              <span v-if="image.exif.model == null">--</span>
              {{ image.exif.model }}
            </div>
          </div>
          <div class="info">
            <div class="camera-title">
              Focal Length
            </div>
            <div class="main-camera-info">
              <span v-if="image.exif.focal_length == null">--</span>
              {{ image.exif.focal_length }}
            </div>
          </div>
          <div class="info">
            <div class="camera-title">
              Aperture
            </div>
            <div class="main-camera-info">
              <span v-if="image.exif.aperture == null">--</span>
              {{ image.exif.aperture }}
            </div>
          </div>
          <div class="info">
            <div class="camera-title">
              Shutter Speed
            </div>
            <div class="main-camera-info">
              <span v-if="image.exif.exposure_time == null">--</span>
              {{ image.exif.exposure_time }}
            </div>
          </div>
          <div class="info">
            <div class="camera-title">
              Dimensions
            </div>
            <div class="main-camera-info">
              {{ image.width }} x {{ image.height }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Photos",
    data() {
      return {
        image: [],
        ready: false,
        value: "",
        active: 0,
        download: "",
      };
    },
    methods: {
      handleUserPage(username) {
        this.$router.push(`/user/${username}`);
      },
      handleDownload(url, id) {
        this.$http({
          url: `${url}`,
          method: "GET",
          responseType: "blob", // important
        }).then(({ data }) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          this.download = url;
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", `${id}.jpg`); //or any other extension
          document.body.appendChild(link);
          link.click();
          console.log(link);
        });
      },
    },
    created() {
      this.$http.get(`/photos/${this.$route.params.id}`).then((res) => {
        this.image = res.data;
        this.ready = true;
        console.log(this.image);
      });
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .photo-info-wrapper {
    width: 100%;
    height: 100%;
    display: flex;

    .photo-wrapper {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      padding-right: 2rem;

      img {
        max-width: 80%;
        max-height: 75vh;
        align-self: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
      }
    }
    .info-wrapper {
      width: 50%;
      height: 100%;
      padding-top: 5rem;
      display: flex;
      flex-direction: column;

      .user-wrapper {
        width: 90%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .left-side {
          display: flex;
          flex-direction: row;
          align-items: center;
          .avatar-wrapper {
            cursor: pointer;
          }
          .name {
            margin-left: 1.5rem;
            font-size: 1.2rem;
            cursor: pointer;
          }
        }

        .btn-wrapper {
          display: flex;
          flex-direction: row;
        }
      }
      .main-info-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 2rem;

        .title {
          font-size: 1.2rem;
          font-weight: 500;
          text-transform: uppercase;
          color: gray;
          margin-bottom: 2rem;
        }
        .stats {
          width: 100%;
          display: flex;
          flex-direction: row;
          margin-bottom: 2rem;

          .main {
            margin-right: 2rem;
            span {
              font-size: 1.1rem;
              font-weight: 500;
              opacity: 0.7;
            }
            .count {
              font-size: 1.4rem;
              font-weight: 700;
              color: #fe8c00;
            }
          }
        }
        .line {
          width: 90%;
          overflow: hidden;
          margin-bottom: 2rem;
          hr {
            border: 1px solid lightgray;
          }
        }
        .camera-info {
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          .info {
            margin-right: 2rem;
            margin-bottom: 1.5rem;
            display: flex;
            flex-direction: column;
            line-height: 20px;
            .camera-title {
              font-size: 16px;
              font-weight: 500;
              text-transform: uppercase;
              color: gray;
            }
            .main-camera-info {
              font-weight: 700;
              color: #2d2d2d;
            }
          }
        }
      }
    }
  }
</style>
